export function LiveAnnouncementBanner({ enabled }: { enabled: boolean }) {
  if (!enabled) return null;
  return (
    <section aria-label="We're live announcement" className="live-announcement overflow-hidden border-y border-primary/25 bg-secondary px-6 py-2.5 text-center text-primary md:py-3">
      <div className="live-announcement-marquee mx-auto max-w-4xl">
        <h2 className="font-display text-xl font-bold leading-tight tracking-normal md:text-2xl">WE'RE LIVE — NOW ACCEPTING ORDERS!</h2>
        <p className="mx-auto mt-1 max-w-3xl text-sm leading-relaxed md:text-base">Fresh, home-style meals, chef-crafted and delivered across Mumbai. Order your favourites online today!</p>
        <p className="mt-1 text-sm font-semibold">Easy online ordering • Secure checkout</p>
      </div>
    </section>
  );
}